import { CollaboratorsApiRemoteService } from "../../Services/api/collaborators/collaborators-service";
import { IFormUsecase } from "../../Shared/Protocol/protocol-form-usecase";
import { Result } from "../../Shared/Protocol/protocol-result";


export class ResetCollaboratorPasswordUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly CollaboratorsApi: CollaboratorsApiRemoteService) {}
    

  public async handle (
    collaboratorId: string
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CollaboratorsApi.resetPassword(collaboratorId)

      if (response.isFailure) {
        return response
      }
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
